import * as React from "react";
import { Base } from "./ui";

const BackImage = ({ backgroundColor, backgroundImage, ...props }) => {
  const ccx = {backgroundImage:'url('+backgroundImage+')', backgroundColor: backgroundColor, backgroundRepeat: 'no-repeat'};
  return <Base as={'div'} backgroundColor={backgroundColor} style={ccx} fadeIn={false} {...props} />;
};

export default BackImage;